// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10ZAP","colBig":"styles_colBig__3K5-m","colSmall":"styles_colSmall__1r1Rg"};